import { render, staticRenderFns } from "./ServiceRegisterAgreeTerms.vue?vue&type=template&id=4ff966d0&"
import script from "./ServiceRegisterAgreeTerms.vue?vue&type=script&lang=ts&"
export * from "./ServiceRegisterAgreeTerms.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports